import React from "react";
import {
  StyledContainer,
  StyledNavigationButton,
  StyledPageLink,
  StyledSelect,
  StyledTruncatedDots,
} from "./Pagination.styled";
import { createPagesArray } from "./createPagesArray";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

interface PaginationProps {
  currentPage: number;
  totalPagesNumber: number;
  onPageChange: (newPage: number) => void;
  pageSize: number;
  allowPageSizeChange?: boolean;
  pageSizeOptions: Array<number>;
  onPageSizeChange: (newPageSize: number) => void;
}

export function Pagination({
  currentPage,
  totalPagesNumber,
  onPageChange,
  pageSize,
  allowPageSizeChange = true,
  pageSizeOptions,
  onPageSizeChange,
}: PaginationProps) {
  const hasPrevious = currentPage !== 0;
  const hasNext = currentPage !== totalPagesNumber - 1;

  const pagesArray = createPagesArray(currentPage, totalPagesNumber);

  if (pagesArray.length === 0) {
    return null;
  }

  return (
    <StyledContainer className="pagination">
      {totalPagesNumber > 1 && (
        <>
          <StyledNavigationButton disabled={!hasPrevious} onClick={() => onPageChange(currentPage - 1)}>
            <ChevronLeftIcon boxSize="18px" ml="-5px" mr="20px" />
            {"Prev"}
          </StyledNavigationButton>
          {pagesArray.map((pageNumber, index) =>
            pageNumber === "..." ? (
              <StyledTruncatedDots className="truncated" key={"truncated-" + index}>
                ...
              </StyledTruncatedDots>
            ) : (
              <StyledPageLink
                className={currentPage + 1 === pageNumber ? "current" : ""}
                key={pageNumber}
                onClick={() => onPageChange(pageNumber - 1)}
              >
                {pageNumber}
              </StyledPageLink>
            )
          )}
          <StyledNavigationButton disabled={!hasNext} onClick={() => onPageChange(currentPage + 1)}>
            {"Next"}
            <ChevronRightIcon boxSize="18px" ml="20px" mr="-5px" />
          </StyledNavigationButton>
        </>
      )}
      {allowPageSizeChange && (
        <StyledSelect
          onChange={(e) => {
            onPageSizeChange(Number(e.target.value));
          }}
          value={pageSize}
        >
          {pageSizeOptions.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </StyledSelect>
      )}
    </StyledContainer>
  );
}
